<template>
  <v-card :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row class="no-gutters align-center">
      <v-col cols="12" sm="8" md="8" lg="10">
        <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here ..."
          single-line solo hide-details>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="2">
        <ul>
          <li>
            <span class="text--green">Total Doc:</span>
            <span>{{ formattedAllNumber(pagination?.total) }}</span>
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12">
        <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
            <v-data-table :headers="headers" :items="documents" :server-items-length="pagination?.total || 10"
              :options.sync="options" :loading="isLoading" :items-per-page="options.itemsPerPage" :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }" @update:options="handleOptionsChange" disable-sort>
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>
              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>
              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ formatMySQLDate(item?.created_at) }}
              </template>

              <template v-slot:item.fname="{ item }">
                <router-link class="text-capitalize text--ash"
                  :to="`/registered-user-details/${item?.client_account_id}`">
                  {{ item?.fname + " " + item?.lname + " (" + item?.client_account_id + ")" }}
                </router-link>
              </template>

              <template v-slot:item.action_by="{ item }">
                {{ item.action_by || "N/A" }}
              </template>

              <template v-slot:item.email="{ item }">
                <v-tooltip top color="#000">
                  <template v-slot:activator="{ on }">
                    <v-btn plain title x-small v-on="on" @click="copyText(item)" style="text-transform: none">
                      {{ obfuscateAnyEmail(item?.email) }}
                      <v-icon x-small class="ml-1" :color="copiedStates[item.id] ? 'green' : ''">
                        {{ copiedStates[item.id] ? "mdi mdi-check" : "mdi-content-copy" }}
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ item.email }}</span>
                </v-tooltip>
              </template>

              <template v-slot:item.document_url="{ item }">
                <v-dialog v-if="isImage(item.document_url)" transition="scale-transition" origin="center center"
                  max-width="554" v-model="dialog[item.id]" content-class="deposit-withdraw-popup">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on" @click="handleClick(item)">
                      <img width="50px" :src="item.document_url" />
                    </span>
                  </template>

                  <template>
                    <v-card class="rounded-0 bg-transparent pa-0" :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'">
                      <v-btn icon color="#172233" @click="closeDialog(item)"
                        style="position: absolute; top: 1rem; right: 1rem; z-index: 1;">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-img class="white--text align-end" :src="selectedItem?.document_url || ''"></v-img>
                    </v-card>
                  </template>
                </v-dialog>
                <v-img v-else width="50px" src="/PDF_icon.png" @click="handleClick(item)"
                  style="cursor: pointer; object-fit: contain" />
              </template>

              <!-- <template v-slot:item.status="{ item }">
                <div class="status-selection">
                  <v-select solo :items="updateslots" append-icon="mdi-chevron-down" class="custom-select"
                    v-model="item.status" item-text="statusText" item-value="status" @change="onUpdateChange(item)">
                    <template v-slot:selection="{ item }">
                      <div :class="getTextColor(item)">
                        {{
                          item.status
                        }}
                      </div>
                    </template>
                  </v-select>
                </div>
              </template> -->

              <template v-slot:item.status="{ item }">
                <div class="status-selection">
                  <v-select solo :items="updateslots" append-icon="mdi-chevron-down" class="custom-select"
                    v-model="item.status" item-text="statusText" item-value="status" @change="onUpdateChange(item)"
                    :disabled="$canRoute('registered-user?tab=2') === false">
                    <template v-slot:selection="{ item }">
                      <div :class="getTextColor(item)">
                        {{ item.status }}
                      </div>
                    </template>
                  </v-select>
                </div>
              </template>


              <template v-slot:item.verification_status="{ item }">
                <v-icon small :class="verifyIcon(item.status)"></v-icon>
                {{
                  item.status
                }}
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import AssignManagerTable from "./AssignManagerTable.vue";
import ProfileVerifyModal from "./ProfileVerifyModal.vue";
import { mapState, mapActions } from "vuex";
import { CLIENTS_DOCUMENTS__ACTIONS } from "@/store/action-types";
import { obfuscateEmail } from "@/_helpers/obfuscateEmail";
import toast from "@/services/Notification";
import { formatMySQLDate } from "@/_helpers/formateDate";
import { formatNumber } from "@/_helpers/formatNumber";

export default {
  data() {
    return {
      search: "",
      searchTimeout: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      isCopied: false,
      copiedStates: {},
      verificationStates: {},
      uploadModal: false,
      searchManagerModal: false,
      dialog: {},
      selectedItem: null,
      updateslots: [
        { status: "Rejected", statusText: "Rejected" },
        { status: "Approved", statusText: "Approved" },
        { status: "Pending", statusText: "Pending" },
      ],
      headers: [
        { text: "Date and Time", align: "start", value: "created_at" },
        { text: "Name", value: "fname" },
        { text: "Email", value: "email" },
        { text: "Document Type", value: "document_type" },
        { text: "Proof", value: "document_url" },
        { text: "Action By", value: "action_by" },
        { text: "Status", value: "verification_status" },
      ],
      details: [
        {
          id: 1,
          para: "Payments from third parties are not accepted. The name of the sender must match the name on your trading account.",
        },
        {
          id: 2,
          para: "GIC Market accepts wire transfers in USD. Funds sent in a different currency will be converted to the deposit currency of your account. You may be charged a fee for the conversion.",
        },
        {
          id: 3,
          para: "The sending bank or correspondent bank may deduct a fee for processing a wire transfer. Demo FX does not apply any fees and will deposit to your account the net amount received.",
        },
        {
          id: 4,
          para: " The sending bank or correspondent bank may deduct a fee for processing a wire transfer. GIC Market does not apply any fees and will deposit to your account the net amount received.",
        },
        {
          id: 5,
          para: "If the transaction goes through, the funds will be posted to your trading account upon receipt by GIC Market.",
        },
      ],
    };
  },
  components: {
    ProfileVerifyModal,
    AssignManagerTable,
  },
  computed: {
    ...mapState("clientsDocuments", ["documents", "isLoading",
      "pagination"]),
    ...mapState("admins", ["loggedAdmin"]),
    
    dateRangeText() {
      return this.date.join(" ~ ");
    },
  },
  methods: {
    formatMySQLDate,
    ...mapActions("clientsDocuments", [
      CLIENTS_DOCUMENTS__ACTIONS.CLIENTS_DOCUMENTS,
      CLIENTS_DOCUMENTS__ACTIONS.VERIFYDOC
    ]),

    async onUpdateChange(item) {
      if (this.loggedAdmin?.access_type === 3) {
        toast.error("You don’t have permission to update this status.");
        return;
      }

      let parameter = {
        id: item?.id,
        status: item.status === "Rejected"
          ? 0
          : item.status === "Approved"
            ? 1
            : 2,
      };

      this[CLIENTS_DOCUMENTS__ACTIONS.VERIFYDOC](parameter);
      await this.fetchData();
    },

    closeModal() {
      this.uploadModal = false;
    },

    getTextColor(item) {
      return item.status === "Approved"
        ? "text-approved"
        : item.status === "Pending"
          ? "text-pending"
          : "text-decline";
    },
    verifyIcon(status) {
      if (status.startsWith("A")) {
        return "mdi mdi-check text--green mr-1";
      } else if (status.startsWith("C")) {
        return "mdi mdi-window-close red--text mr-1";
      } else {
        return "mdi mdi-refresh mr-1 yellow--text";
      }
    },
    verifyModal(status) {
      if (status.startsWith("A")) return "d-none ml-0";
      else if (status.startsWith("C")) return "d-block ml-2";
      else return "d-block ml-2";
    },
    obfuscateAnyEmail(email) {
      return obfuscateEmail(email)
    },
    copyText(item) {
      navigator.clipboard.writeText(item.email);
      this.$set(this.copiedStates, item.id, true);
      setTimeout(() => {
        this.$set(this.copiedStates, item.id, false);
      }, 1000);
    },
    handleClick(item) {
      if (this.isImage(item.document_url)) {
        this.showDialog(item);
      } else {
        window.open(item.document_url, "_blank");
      }
    },
    showDialog(item) {
      if (this.isImage(item.document_url)) {
        this.$set(this.dialog, item.id, true);
      } else {
        window.open(item.document_url, "_blank");
      }
      this.selectedItem = item;
    },
    isImage(url) {
      const imageExtensions = [".jpg", ".jpeg", ".png", ".webp"];
      return imageExtensions.some((ext) => url.toLowerCase().endsWith(ext));
    },
    closeDialog(item) {
      this.$set(this.dialog, item.id, false);
      this.selectedItem = null;
    },
    async fetchData() {
      const parameter = {
        page: this.options.page || 1,
        limit: this.options.itemsPerPage || 10,
        search: this.search,
      };

      await this[CLIENTS_DOCUMENTS__ACTIONS.CLIENTS_DOCUMENTS](parameter);
    },

    async handleSearch(value) {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },
  },
  async created() {
    await this.fetchData();
    this.selectedSlot = "Approved";

    if (this.documents) {
      this.documents.forEach(doc => {
        this.$set(this.verificationStates, doc.id, null);
      });
    }

    if (this.$canRoute('registered-user?tab=2') === 1) {
      this.headers.push({ text: "Action", value: "status" });
    }
  },
};
</script>

<style scoped>
.verification-select {
  max-width: 150px;
}
</style>